/* eslint-disable perfectionist/sort-imports */
/* eslint-disable perfectionist/sort-objects */
// 30 x 30 (Orders page)
import * as apcPostalIcon from '~/assets/icons/providers/apc_postal.svg';
import * as asendiaUSIcon from '~/assets/icons/providers/asendia.svg';
import * as australiaPostIcon from '~/assets/icons/providers/australia_post.svg';
import * as axlehireIcon from '~/assets/icons/providers/axlehire.svg';
import * as airterraIcon from '~/assets/icons/providers/airterra.svg';
import * as betterTrucksIcon from '~/assets/icons/providers/better_trucks.svg';
import * as canadaPostIcon from '~/assets/icons/providers/canada_post.svg';
import * as cdlIcon from '~/assets/icons/providers/cdl.svg';
import * as chronopostIcon from '~/assets/icons/providers/chronopost.svg';
import * as colissimoIcon from '~/assets/icons/providers/colissimo.svg';
import * as correosIcon from '~/assets/icons/providers/correos.svg';
import * as courierspleaseIcon from '~/assets/icons/providers/couriers_please.svg';
import * as deutschePostIcon from '~/assets/icons/providers/deutsche_post.svg';
import * as dhlIcon from '~/assets/icons/providers/dhl_all.svg';
import * as dpdIcon from '~/assets/icons/providers/dpd.svg';
import * as evriUKIcon from '~/assets/icons/providers/evri_uk.svg';
import * as fastwayAustraliaIcon from '~/assets/icons/providers/fastway.svg';
import * as fedexIcon from '~/assets/icons/providers/fedex.svg';
import * as globegisticsIcon from '~/assets/icons/providers/globegistics.svg';
import * as glsIcon from '~/assets/icons/providers/gls.svg';
import * as lasershipIcon from '~/assets/icons/providers/lasership.svg';
import * as lsoIcon from '~/assets/icons/providers/LSO.svg';
import * as maergoIcon from '~/assets/icons/providers/maergo.svg';
import * as mondialrelayIcon from '~/assets/icons/providers/mondial_relay.svg';
import * as newgisticsIcon from '~/assets/icons/providers/newgistics.svg';
import * as ontracIcon from '~/assets/icons/providers/ontrac.svg';
import * as orangeDsIcon from '~/assets/icons/providers/orange_ds.svg';
import * as parcel2goIcon from '~/assets/icons/providers/parcel2go.svg';
import * as parcelforceIcon from '~/assets/icons/providers/parcel_force.svg';
import * as passportIcon from '~/assets/icons/providers/passport.svg';
import * as pitneyBowesIcon from '~/assets/icons/providers/pitney_bowes.svg';
import * as posteItalianeIcon from '~/assets/icons/providers/poste_italiane.svg';
import * as purolatorIcon from '~/assets/icons/providers/purolator.svg';
import * as rrDonnelleyIcon from '~/assets/icons/providers/rr_donnelley.svg';
import * as royalMailIcon from '~/assets/icons/providers/royal_mail.svg';
import * as sendleIcon from '~/assets/icons/providers/sendle.svg';
import * as swyftIcon from '~/assets/icons/providers/swyft.svg';
import * as udsIcon from '~/assets/icons/providers/uds.svg';
import * as upsIcon from '~/assets/icons/providers/UPS.svg';
import * as uspsIcon from '~/assets/icons/providers/USPS.svg';
import * as vehoIcon from '~/assets/icons/providers/veho.svg';
import * as amazonShippingIcon from '~/assets/icons/providers/amazon_shipping.svg';

// 200
import * as airterraImg200 from '~/assets/providers/200/airterra.png';
import * as apcPostalImg200 from '~/assets/providers/200/apc_postal.png';
import * as axlehireImg200 from '~/assets/providers/200/axlehire.png';
import * as betterTrucksImg200 from '~/assets/providers/200/better_trucks.png';
import * as canadaPostImg200 from '~/assets/providers/200/canada_post.png';
import * as cdlImg200 from '~/assets/providers/200/cdl.png';
import * as chronopostImg200 from '~/assets/providers/200/chronopost.png';
import * as correosImg200 from '~/assets/providers/200/correos.png';
import * as courierspleaseImg200 from '~/assets/providers/200/couriersplease.png';
import * as deutschePostImg200 from '~/assets/providers/200/deutsche_post.png';
import * as dhlEcommerceImg200 from '~/assets/providers/200/dhl_ecommerce.png';
import * as dhlExpressImg200 from '~/assets/providers/200/dhl_express.png';
import * as dhlGermanyImg200 from '~/assets/providers/200/dhl_germany.png';
import * as evriUKImg200 from '~/assets/providers/200/evri_uk.png';
import * as fastwayAustraliaImg200 from '~/assets/providers/200/fastway_australia.png';
import * as fedexImg200 from '~/assets/providers/200/fedex.png';
import * as globegisticsImg200 from '~/assets/providers/200/globegistics.png';
import * as glsUSImg200 from '~/assets/providers/200/gls_us.png';
import * as lasershipImg200 from '~/assets/providers/200/lasership.png';
import * as lsoImg200 from '~/assets/providers/200/lso.png';
import * as mondialrelayImg200 from '~/assets/providers/200/mondialrelay.png';
import * as newgisticsImg200 from '~/assets/providers/200/newgistics.png';
import * as orangeDsImg200 from '~/assets/providers/200/orange_ds.png';
import * as orangeDsImg260 from '~/assets/providers/260/orange_ds.png';
import * as parcel2goImg200 from '~/assets/providers/200/parcel2go.png';
import * as passportImg200 from '~/assets/providers/200/passport.png';
import * as pitneyBowesImg200 from '~/assets/providers/200/pitney_bowes.png';
import * as posteItalianeImg200 from '~/assets/providers/200/poste_italiane.png';
import * as royalMail200 from '~/assets/providers/200/royal_mail.png';
import * as sendleImg200 from '~/assets/providers/200/sendle.png';
import * as swyftImg200 from '~/assets/providers/200/swyft.png';
import * as udsImg200 from '~/assets/providers/200/uds.png';
import * as upsImg200 from '~/assets/providers/200/ups.png';
import * as uspsImg200 from '~/assets/providers/200/usps.png';
import * as vehoImg200 from '~/assets/providers/200/veho.png';
import * as amazonShippingImg200 from '~/assets/providers/200/amazon_shipping.png';

//  75 x 23-50 (Shipments page)
import * as airterraImg from '~/assets/providers/75/airterra.png';
import * as apcPostalImg from '~/assets/providers/75/apc_postal.png';
import * as asendiaUSImg from '~/assets/providers/75/asendia_us.png';
import * as australiaPostImg from '~/assets/providers/75/australia_post.png';
import * as axlehireImg from '~/assets/providers/75/axlehire.png';
import * as betterTrucksImg from '~/assets/providers/75/better_trucks.png';
import * as canadaPostImg from '~/assets/providers/75/canada_post.png';
import * as cdlImg from '~/assets/providers/75/cdl.png';
import * as chronopostImg from '~/assets/providers/75/chronopost.png';
import * as colissimoImg from '~/assets/providers/75/colissimo.png';
import * as correosImg from '~/assets/providers/75/correos.png';
import * as courierspleaseImg from '~/assets/providers/75/couriersplease.png';
import * as deutschePostImg from '~/assets/providers/75/deutsche_post.png';
import * as dhlEcommerceImg from '~/assets/providers/75/dhl_ecommerce.png';
import * as dhlExpressImg from '~/assets/providers/75/dhl_express.png';
import * as dhlGermanyImg from '~/assets/providers/75/dhl_germany.png';
import * as dpdImg from '~/assets/providers/75/dpd.png';
import * as evriUKImg from '~/assets/providers/75/evri_uk.png';
import * as fastwayAustraliaImg from '~/assets/providers/75/fastway_australia.png';
import * as fedexExpressImg from '~/assets/providers/75/FedEx_Express.png';
import * as fedexImg from '~/assets/providers/75/fedex.png';
import * as globegisticsImg from '~/assets/providers/75/globegistics.png';
import * as glsUSImg from '~/assets/providers/75/gls_us.png';
import * as lasershipImg from '~/assets/providers/75/lasership.png';
import * as lsoImg from '~/assets/providers/75/lso.png';
import * as maergoImg from '~/assets/providers/75/maergo.png';
import * as mondialrelayImg from '~/assets/providers/75/mondialrelay.png';
import * as newgisticsImg from '~/assets/providers/75/newgistics.png';
import * as ontracImg from '~/assets/providers/75/ontrac.png';
import * as orangeDsImg from '~/assets/providers/75/orange_ds.png';
import * as parcel2goImg from '~/assets/providers/75/parcel2go.png';
import * as parcelforceImg from '~/assets/providers/75/parcelforce.png';
import * as passportImg from '~/assets/providers/75/passport.png';
import * as pitneyBowesImg from '~/assets/providers/75/pitney_bowes.png';
import * as posteItalianeImg from '~/assets/providers/75/poste_italiane.png';
import * as purolatorImg from '~/assets/providers/75/purolator.png';
import * as royalMailImg from '~/assets/providers/75/royal_mail.png';
import * as rrDonnelleyImg from '~/assets/providers/75/rr_donnelley.png';
import * as sendleImg from '~/assets/providers/75/sendle.png';
import * as swyftImg from '~/assets/providers/75/swyft.png';
import * as udsImg from '~/assets/providers/75/uds.png';
import * as upsImg from '~/assets/providers/75/ups.png';
import * as uspsImg from '~/assets/providers/75/usps.png';
import * as vehoImg from '~/assets/providers/75/veho.png';
import * as amazonShippingImg from '~/assets/providers/75/amazon_shipping.png';

// 260 x 160 (Carriers page)
import * as apcPostalImg260 from '~/assets/providers/vector/logos/apc.svg';
import * as asendiaUSImg260 from '~/assets/providers/vector/logos/asendia.svg';
import * as australiaPostImg260 from '~/assets/providers/vector/logos/australia_post.svg';
import * as axlehireImg260 from '~/assets/providers/vector/logos/axlehire.svg';
import * as betterTrucksImg260 from '~/assets/providers/vector/logos/better_trucks.svg';
import * as canadaPostImg260 from '~/assets/providers/vector/logos/canada_post.svg';
import * as cdlImg260 from '~/assets/providers/vector/logos/CDL.svg';
import * as chronopostImg260 from '~/assets/providers/vector/logos/chronopost.svg';
import * as colissimoImg260 from '~/assets/providers/vector/logos/colissimo.svg';
import * as correosImg260 from '~/assets/providers/vector/logos/correos.svg';
import * as courierspleaseImg260 from '~/assets/providers/vector/logos/couriers_please.svg';
import * as deutschePostImg260 from '~/assets/providers/vector/logos/deutsche_post.svg';
import * as dhlEcommerceImg260 from '~/assets/providers/vector/logos/dhl_ecommerce.svg';
import * as dhlExpressImg260 from '~/assets/providers/vector/logos/dhl_express.svg';
import * as dhlGermanyImg260 from '~/assets/providers/vector/logos/dhl_germany.svg';
import * as dpdImg260 from '~/assets/providers/vector/logos/dpd.svg';
import * as evriUKImg260 from '~/assets/providers/vector/logos/evri_uk.svg';
import * as fastwayAustraliaImg260 from '~/assets/providers/vector/logos/fastway.svg';
import * as fedexImg260 from '~/assets/providers/vector/logos/fedex.svg';
import * as globegisticsImg260 from '~/assets/providers/vector/logos/globegistics.svg';
import * as glsUSImg260 from '~/assets/providers/vector/logos/gls_us.svg';
import * as lasershipImg260 from '~/assets/providers/vector/logos/lasership.svg';
import * as lsoImg260 from '~/assets/providers/vector/logos/lso.svg';
import * as maergoImg260 from '~/assets/providers/vector/logos/maergo.svg';
import * as mondialrelayImg260 from '~/assets/providers/vector/logos/mondial_relay.svg';
import * as newgisticsImg260 from '~/assets/providers/vector/logos/newgistics.svg';
import * as ontracImg260 from '~/assets/providers/vector/logos/ontrac.svg';
import * as parcelforceImg260 from '~/assets/providers/vector/logos/parcel_force.svg';
import * as passportImg260 from '~/assets/providers/vector/logos/passport.svg';
import * as posteItalianeImg260 from '~/assets/providers/vector/logos/poste_italiane.svg';
import * as purolatorImg260 from '~/assets/providers/vector/logos/purolator.svg';
import * as rrDonnelleyImg260 from '~/assets/providers/vector/logos/rr_donnelley.svg';
import * as sendleImg260 from '~/assets/providers/vector/logos/sendle.svg';
import * as swyftImg260 from '~/assets/providers/vector/logos/swyft.svg';
import * as udsImg260 from '~/assets/providers/vector/logos/uds.svg';
import * as upsImg260 from '~/assets/providers/vector/logos/ups.svg';
import * as uspsImg260 from '~/assets/providers/vector/logos/usps.svg';
import * as vehoImg260 from '~/assets/providers/vector/logos/veho.svg';
import * as amazonShippingImg260 from '~/assets/providers/vector/logos/amazon_shipping.svg';

import { countries, type CountryIso2 } from '~/constants/countries';
import type Carrier from '~/types/Carrier';
import { normalizeCarrierName } from '~/types/Carrier';
import { FeatureFlags, decideFeatureFlag } from '~/utils/featureflags';

export type CarriersByRegion = Record<string, Carrier[]>;

const APC_POSTAL: Carrier = {
  id: 'apc_postal',
  providerToken: 'apc_postal',
  name: 'APC Postal',
  img: apcPostalImg,
  img200: apcPostalImg200,
  img260: apcPostalImg260,
  icon: apcPostalIcon,
};

const ASENDIA_US: Carrier = {
  id: 'asendia_us',
  providerToken: 'asendia_us',
  name: 'Asendia US',
  img: asendiaUSImg,
  img200: null,
  img260: asendiaUSImg260,
  icon: asendiaUSIcon,
};

export const AUSTRALIA_POST: Carrier = {
  id: 'australia_post',
  providerToken: 'australia_post',
  name: 'Australia Post',
  img: australiaPostImg,
  img200: null,
  img260: australiaPostImg260,
  icon: australiaPostIcon,
};

const AXLEHIRE: Carrier = {
  id: 'axlehire',
  providerToken: 'axlehire',
  name: 'AxleHire',
  img: axlehireImg,
  img200: axlehireImg200,
  img260: axlehireImg260,
  icon: axlehireIcon,
};

export const AIRTERRA: Carrier = {
  id: 'airterra',
  providerToken: 'airterra',
  name: 'Airterra',
  img: airterraImg,
  img200: airterraImg200,
  img260: airterraImg200,
  icon: airterraIcon,
};

const BETTER_TRUCKS: Carrier = {
  id: 'better_trucks',
  providerToken: 'better_trucks',
  name: 'BetterTrucks',
  img: betterTrucksImg,
  img200: betterTrucksImg200,
  img260: betterTrucksImg260,
  icon: betterTrucksIcon,
};

export const CANADA_POST: Carrier = {
  id: 'canada_post',
  providerToken: 'canada_post',
  name: 'Canada Post',
  img: canadaPostImg,
  img200: canadaPostImg200,
  img260: canadaPostImg260,
  icon: canadaPostIcon,
};

const CDL: Carrier = {
  id: 'cdl',
  providerToken: 'cdl',
  name: 'CDL',
  img: cdlImg,
  img200: cdlImg200,
  img260: cdlImg260,
  icon: cdlIcon,
};

const CHRONOPOST: Carrier = {
  id: 'chronopost',
  providerToken: 'chronopost',
  name: 'Chronopost',
  img: chronopostImg,
  img200: chronopostImg200,
  img260: chronopostImg260,
  icon: chronopostIcon,
};

const COLISSIMO: Carrier = {
  id: 'colissimo',
  providerToken: 'colissimo',
  name: 'Colissimo',
  img: colissimoImg,
  img200: null,
  img260: colissimoImg260,
  icon: colissimoIcon,
};

const CORREOS: Carrier = {
  id: 'correos',
  providerToken: 'correos',
  name: 'Correos',
  img: correosImg,
  img200: correosImg200,
  img260: correosImg260,
  icon: correosIcon,
};

const COURIERSPLEASE: Carrier = {
  id: 'couriersplease',
  providerToken: 'couriersplease',
  name: 'CouriersPlease',
  img: courierspleaseImg,
  img200: courierspleaseImg200,
  img260: courierspleaseImg260,
  icon: courierspleaseIcon,
};

const DEUTSCHE_POST: Carrier = {
  id: 'deutsche_post',
  providerToken: 'deutsche_post',
  name: 'Deutsche Post',
  img: deutschePostImg,
  img200: deutschePostImg200,
  img260: deutschePostImg260,
  icon: deutschePostIcon,
};

const DHL_ECOMMERCE: Carrier = {
  id: 'dhl_ecommerce',
  providerToken: 'dhl_ecommerce',
  name: 'DHL eCommerce',
  img: dhlEcommerceImg,
  img200: dhlEcommerceImg200,
  img260: dhlEcommerceImg260,
  icon: dhlIcon,
};

export const DHL_EXPRESS: Carrier = {
  id: 'dhl_express',
  providerToken: 'dhl_express',
  name: 'DHL Express',
  img: dhlExpressImg,
  img200: dhlExpressImg200,
  img260: dhlExpressImg260,
  icon: dhlIcon,
};

export const DHL_GERMANY: Carrier = {
  id: 'dhl_germany',
  providerToken: 'dhl_germany',
  name: 'DHL Germany',
  img: dhlGermanyImg,
  img200: dhlGermanyImg200,
  img260: dhlGermanyImg260,
  icon: dhlIcon,
};

const DHL_GERMANY_C2C: Carrier = {
  id: 'dhl_germany_c2c',
  providerToken: 'dhl_germany_c2c',
  name: 'DHL Germany C2C',
  img: dhlGermanyImg,
  img200: dhlGermanyImg200,
  img260: dhlGermanyImg260,
  icon: dhlIcon,
};

const DPD_DE: Carrier = {
  id: 'dpd_de',
  providerToken: 'dpd_de',
  name: 'DPD DE',
  img: dpdImg,
  img200: null,
  img260: dpdImg260,
  icon: dpdIcon,
};

const DPD_UK: Carrier = {
  id: 'dpd_uk',
  providerToken: 'dpd_uk',
  name: 'DPD UK',
  img: dpdImg,
  img200: null,
  img260: dpdImg260,
  icon: dpdIcon,
};

export const FASTWAY_AUSTRALIA: Carrier = {
  id: 'fastway_australia',
  providerToken: 'fastway_australia',
  name: 'Fastway Australia',
  img: fastwayAustraliaImg,
  img200: fastwayAustraliaImg200,
  img260: fastwayAustraliaImg260,
  icon: fastwayAustraliaIcon,
};

export const FEDEX: Carrier = {
  id: 'fedex',
  providerToken: 'fedex',
  name: 'FedEx',
  img: fedexImg,
  img200: fedexImg200,
  img260: fedexImg260,
  imgTrademark: fedexExpressImg, // Used for FedEx package templates
  icon: fedexIcon,
};

const GLOBEGISTICS: Carrier = {
  id: 'globegistics',
  providerToken: 'globegistics',
  name: 'Globegistics',
  img: globegisticsImg,
  img200: globegisticsImg200,
  img260: globegisticsImg260,
  icon: globegisticsIcon,
};

const GLS_US: Carrier = {
  id: 'gls_us',
  providerToken: 'gls_us',
  name: 'GLS US',
  img: glsUSImg,
  img200: glsUSImg200,
  img260: glsUSImg260,
  icon: glsIcon,
};

const HERMES_UK: Carrier = {
  id: 'hermes_uk',
  providerToken: 'hermes_uk',
  name: 'Evri UK',
  img: evriUKImg,
  img200: evriUKImg200,
  img260: evriUKImg260,
  icon: evriUKIcon,
};

const LASERSHIP: Carrier = {
  id: 'lasership',
  providerToken: 'lasership',
  name: 'Lasership',
  img: lasershipImg,
  img200: lasershipImg200,
  img260: lasershipImg260,
  icon: lasershipIcon,
};

export const LSO: Carrier = {
  id: 'lso',
  providerToken: 'lso',
  name: 'LSO',
  img: lsoImg,
  img200: lsoImg200,
  img260: lsoImg260,
  icon: lsoIcon,
};

const MONDIALRELAY: Carrier = {
  id: 'mondial_relay',
  providerToken: 'mondial_relay',
  name: 'Mondial Relay',
  img: mondialrelayImg,
  img200: mondialrelayImg200,
  img260: mondialrelayImg260,
  icon: mondialrelayIcon,
};

const NEWGISTICS: Carrier = {
  id: 'newgistics',
  providerToken: 'newgistics',
  name: 'Newgistics',
  img: newgisticsImg,
  img200: newgisticsImg200,
  img260: newgisticsImg260,
  icon: newgisticsIcon,
};

const ONTRAC: Carrier = {
  id: 'ontrac',
  providerToken: 'ontrac',
  name: 'OnTrac',
  img: ontracImg,
  img200: null,
  img260: ontracImg260,
  icon: ontracIcon,
};

/**
 * Orange DS carrier.
 * DEFUNCT: Ceased operations November 2024.
 */
const ORANGEDS: Carrier = {
  id: 'orangeds',
  providerToken: 'orangeds',
  name: 'Orange DS',
  img: orangeDsImg,
  img200: orangeDsImg200,
  img260: orangeDsImg260,
  icon: orangeDsIcon,
};

const PARCEL2GO: Carrier = {
  id: 'parcel2go',
  providerToken: 'parcel2go',
  name: 'Parcel2Go UK',
  img: parcel2goImg,
  img200: parcel2goImg200,
  img260: null,
  icon: parcel2goIcon,
};

const PARCELFORCE: Carrier = {
  id: 'parcelforce',
  providerToken: 'parcelforce',
  name: 'Parcelforce',
  img: parcelforceImg,
  img200: null,
  img260: parcelforceImg260,
  icon: parcelforceIcon,
};

const PASSPORT: Carrier = {
  id: 'passport',
  providerToken: 'passport',
  name: 'Passport',
  img: passportImg,
  img200: passportImg200,
  img260: passportImg260,
  icon: passportIcon,
};

const PITNEY_BOWES: Carrier = {
  id: 'pitney_bowes',
  providerToken: 'pitney_bowes',
  name: 'Pitney Bowes',
  img: pitneyBowesImg,
  img200: pitneyBowesImg200,
  img260: undefined,
  icon: pitneyBowesIcon,
};

const POSTE_ITALIANE: Carrier = {
  id: 'poste_italiane',
  providerToken: 'poste_italiane',
  name: 'Poste Italiane',
  img: posteItalianeImg,
  img200: posteItalianeImg200,
  img260: posteItalianeImg260,
  icon: posteItalianeIcon,
};

const PUROLATOR: Carrier = {
  id: 'purolator',
  providerToken: 'purolator',
  name: 'Purolator',
  img: purolatorImg,
  img200: null,
  img260: purolatorImg260,
  icon: purolatorIcon,
};

const RR_DONNELLEY: Carrier = {
  id: 'rr_donnelley',
  providerToken: 'rr_donnelley',
  name: 'ePost Global',
  img: rrDonnelleyImg,
  img200: null,
  img260: rrDonnelleyImg260,
  icon: rrDonnelleyIcon,
};

const ROYAL_MAIL: Carrier = {
  id: 'royal_mail',
  providerToken: 'royal_mail',
  name: 'Royal Mail',
  img: royalMailImg,
  img200: royalMail200,
  img260: royalMail200,
  icon: royalMailIcon,
};

export const ROYAL_MAIL_SF: Carrier = {
  id: 'royal_mail_sf',
  providerToken: 'royal_mail_sf',
  name: 'Royal Mail',
  img: royalMailImg,
  img200: royalMail200,
  img260: royalMail200,
  icon: royalMailIcon,
};

const SENDLE: Carrier = {
  id: 'sendle',
  providerToken: 'sendle',
  name: 'Sendle',
  img: sendleImg,
  img200: sendleImg200,
  img260: sendleImg260,
  icon: sendleIcon,
};

const SWYFT: Carrier = {
  id: 'swyft',
  providerToken: 'swyft',
  name: 'Swyft',
  img: swyftImg,
  img200: swyftImg200,
  img260: swyftImg260,
  icon: swyftIcon,
};

const UDS: Carrier = {
  id: 'uds',
  providerToken: 'uds',
  name: 'UDS',
  img: udsImg,
  img200: udsImg200,
  img260: udsImg260,
  icon: udsIcon,
};

export const UPS: Carrier = {
  id: 'ups',
  providerToken: 'ups',
  name: 'UPS',
  img: upsImg,
  img200: upsImg200,
  img260: upsImg260,
  icon: upsIcon,
};

export const USPS: Carrier = {
  id: 'usps',
  providerToken: 'usps',
  name: 'USPS',
  img: uspsImg,
  img200: uspsImg200,
  img260: uspsImg260,
  icon: uspsIcon,
};

const VEHO: Carrier = {
  id: 'veho',
  providerToken: 'veho',
  name: 'Veho',
  img: vehoImg,
  img200: vehoImg200,
  img260: vehoImg260,
  icon: vehoIcon,
};

export const AMAZON_SHIPPING: Carrier = {
  id: 'amazon_shipping',
  providerToken: 'amazon_shipping',
  name: 'Amazon Shipping',
  img: amazonShippingImg,
  img200: amazonShippingImg200,
  img260: amazonShippingImg260,
  icon: amazonShippingIcon,
};

/**
 * X Delivery carrier.
 * DEFUNCT: Ceased operations June/July 2024.
 */
const X_DELIVERY: Carrier = {
  id: 'x_delivery',
  providerToken: 'x_delivery',
  name: 'Maergo',
  img: maergoImg,
  img200: null,
  img260: maergoImg260,
  icon: maergoIcon,
};

const carriers = [
  AIRTERRA,
  APC_POSTAL,
  ASENDIA_US,
  AUSTRALIA_POST,
  AXLEHIRE,
  BETTER_TRUCKS,
  CANADA_POST,
  CDL,
  CHRONOPOST,
  COLISSIMO,
  CORREOS,
  COURIERSPLEASE,
  DEUTSCHE_POST,
  DHL_GERMANY,
  DHL_GERMANY_C2C,
  DHL_ECOMMERCE,
  DHL_EXPRESS,
  DPD_DE,
  DPD_UK,
  FASTWAY_AUSTRALIA,
  FEDEX,
  GLOBEGISTICS,
  GLS_US,
  HERMES_UK,
  LASERSHIP,
  LSO,
  MONDIALRELAY,
  NEWGISTICS,
  ONTRAC,
  ORANGEDS,
  PARCEL2GO,
  PARCELFORCE,
  PASSPORT,
  PITNEY_BOWES,
  // PCF,
  POSTE_ITALIANE,
  PUROLATOR,
  ROYAL_MAIL,
  ROYAL_MAIL_SF,
  RR_DONNELLEY,
  SENDLE,
  SWYFT,
  UDS,
  UPS,
  USPS,
  VEHO,
  AMAZON_SHIPPING,
  X_DELIVERY,
];

/**
 * These carriers ceased operations and should no longer be visible in carrier settings.
 * We need to keep them in the codebase so that old labels still display correctly.
 */
export const defunctCarriers = [ORANGEDS, X_DELIVERY];

export const carrierRebrandMap = {
  'Hermes UK': 'Evri UK',
  'X Delivery': 'Maergo',
  'Royal Mail SF': 'Royal Mail',
};

export const UPS_TECH_AGREEMENT_URL = `https://assets.ups.com/adobe/assets/urn:aaid:aem:c271a615-2207-4626-8507-521abe266d37/original/as/uta-en-GLOBAL.pdf`;
export const UPS_TARIFF_AGREEMENT_URL = 'https://shippo.com/US-TToCoS';
export const UPS_PROHIBITED_ITEMS_URL = 'https://shippo.com/US-LoPI';
export const UPS_GROUND_SAVER_AGREEMENT_URL =
  'https://www.ups.com/assets/resources/media/en_US/Ground-Saver.pdf';
export const UPS_SURCHARGE_WARNING_URL =
  'https://support.goshippo.com/hc/en-us/articles/115004734443-Understanding-Postal-Surcharges-in-Shippo#h_01K2XP1XDPNQFK05RWSRGPRTWR';

export const UPS_CA_TECH_AGREEMENT_URL = `https://assets.ups.com/adobe/assets/urn:aaid:aem:c271a615-2207-4626-8507-521abe266d37/original/as/uta-en-GLOBAL.pdf`;
export const UPS_CA_TARIFF_AGREEMENT_URL = 'https://shippo.com/CA-TToCos';
export const UPS_CA_PROHIBITED_ITEMS_URL = 'https://shippo.com/CA-LoPI';

export const CANADA_POST_PROMO_TERMS_AGREEMENT_URL = `https://www.canadapost-postescanada.ca/tools/pg/serviceoverview/ParcelsContractCustomersCanada-e.asp`;
export const CANADA_POST_PROMO_PRIVACY_POLICY_URL = `https://www.canadapost-postescanada.ca/cpc/en/our-company/about-us/privacy-policy/privacy-policy-introduction.page`;

export const DHL_EXPRESS_TERMS_AGREEMENT_URL = `https://mydhl.express.dhl/ba/en/legal/terms-and-conditions.html`;

export const ROYAL_MAIL_SF_TERMS_AGREEMENT_URL = `https://help.parcel.royalmail.com/hc/en-gb/articles/360004605273-Click-Drop-Terms-and-Conditions`;
export const ROYAL_MAIL_SF_NON_ACCOUNT_TERMS_AGREEMENT_URL = `https://www.royalmail.com/non-account-terms-and-conditions`;

const masterAccountCarriersBase: { [region: string]: Carrier[] } = {
  'U.S. Domestic': [AMAZON_SHIPPING, USPS, UPS, FEDEX],
  'U.S. Regional': [LSO],
  'U.S. International': [USPS, DHL_EXPRESS, UPS, FEDEX],
  Canada: [CANADA_POST, UPS],
  Europe: [
    PARCELFORCE,
    DEUTSCHE_POST,
    HERMES_UK,
    DPD_DE,
    DPD_UK,
    COLISSIMO,
    CHRONOPOST,
    CORREOS,
    MONDIALRELAY,
    POSTE_ITALIANE,
    ROYAL_MAIL_SF,
  ],
  Australia: [FASTWAY_AUSTRALIA, COURIERSPLEASE, SENDLE],
};

export const getMasterAccountCarriers = (): CarriersByRegion => {
  const amazonShippingAccountRegistrationEnabled =
    decideFeatureFlag(FeatureFlags.AMAZON_SHIPPING_ACCOUNT_REGISTRATION)?.enabled ?? false;

  const isEnabled = (c: Carrier) =>
    amazonShippingAccountRegistrationEnabled || c !== AMAZON_SHIPPING;

  return Object.entries(masterAccountCarriersBase).reduce((acc, [region, carriers]) => {
    acc[region] = carriers.filter(isEnabled);
    return acc;
  }, {} as CarriersByRegion);
};

export const masterAccountCarriersRegionUPS: Partial<Record<string, CountryIso2>> = {
  'U.S. Domestic': countries.US.iso2,
  'U.S. International': countries.US.iso2,
  Canada: countries.CA.iso2,
};

export const masterAccountCarrierDescriptions = {
  'U.S. Domestic': {
    [AMAZON_SHIPPING.id]: [
      'carriers.descriptions.domestic.amazon_shipping.discounts',
      'carriers.descriptions.domestic.amazon_shipping.pickups',
    ],
    [FEDEX.id]: ['carriers.descriptions.domestic.fedex.discounts'],
    [UPS.id]: ['carriers.descriptions.domestic.ups.discounts'],
    [USPS.id]: [
      'carriers.descriptions.domestic.usps.discounts',
      'carriers.descriptions.domestic.usps.pickups',
      'carriers.descriptions.domestic.usps.manifests',
    ],
  },
  'U.S. Regional': {
    [LSO.id]: [
      'carriers.descriptions.regional.lso.discounts',
      'carriers.descriptions.regional.lso.shipments',
      'carriers.descriptions.regional.lso.pickups',
    ],
  },
  'U.S. International': {
    [UPS.id]: ['carriers.descriptions.international.ups.discounts'],
    [USPS.id]: [
      'carriers.descriptions.international.usps.discounts',
      'carriers.descriptions.international.usps.pickups',
      'carriers.descriptions.international.usps.manifests',
    ],
    [DHL_EXPRESS.id]: [
      'carriers.descriptions.international.dhl_express.discounts',
      'carriers.descriptions.international.dhl_express.pickups',
      'carriers.descriptions.international.dhl_express.customs',
    ],
  },
  Canada: {
    [UPS.id]: ['carriers.descriptions.canada.ups.discounts'],
    [CANADA_POST.id]: [
      'carriers.descriptions.canada.canada_post.discounts',
      'carriers.descriptions.canada.canada_post.reach',
      'carriers.descriptions.canada.canada_post.access',
    ],
  },
  Europe: {},
  Australia: {},
};

export const carrierHashMap = carriers.reduce<Record<string, Carrier>>((hash, carrier: Carrier) => {
  hash[carrier.id] = carrier;
  hash[normalizeCarrierName(carrier.name)] = carrier;

  return hash;
}, {});

export const CARRIERS_WITH_DATE_SELECTOR_IN_PICKUPS = [DHL_EXPRESS.name];

export const CARRIERS_WITH_DATE_ONLY_IN_PICKUPS: Record<
  string,
  { endTime: string; startTime: string }
> = {
  [AMAZON_SHIPPING.name]: { endTime: '17:00', startTime: '09:00' },
};
/**
 * Carriers whose pickup address is locked to the shipment's sender address and
 * cannot be edited from the pickup form. This is typically due to carrier restrictions
 */
export const CARRIERS_WITHOUT_PICKUP_ADDRESS_CHANGE = [AMAZON_SHIPPING.name];

/**
 * Day offsets (relative to "today" in the user's local time) used to build the
 * start/end date range when fetching pickup transactions, as well as the
 * selectable range in the pickup date picker.
 *
 * Amazon Shipping pickups can only be scheduled from tomorrow up to 10 days in
 * the future, so today is excluded. Every other carrier keeps the legacy
 * today → tomorrow range.
 */
export const DEFAULT_PICKUP_TRANSACTION_DATE_RANGE = {
  endDayOffset: 1,
  startDayOffset: 0,
};

export const PICKUP_TRANSACTION_DATE_RANGE_BY_CARRIER: Record<
  string,
  { endDayOffset: number; startDayOffset: number }
> = {
  [AMAZON_SHIPPING.name]: { endDayOffset: 10, startDayOffset: 1 },
};

export const getPickupTransactionDateRange = (carrierName: string) =>
  PICKUP_TRANSACTION_DATE_RANGE_BY_CARRIER[carrierName] ?? DEFAULT_PICKUP_TRANSACTION_DATE_RANGE;

export const AMAZON_SHIPPING_DROP_OFF_URL = 'https://shipping.amazon.com/locations';

export const isAmazonShippingProvider = (provider: string) => provider === AMAZON_SHIPPING.name;

const topCarriers = [USPS, FEDEX, UPS, DHL_EXPRESS];
export const popularCarriers = [UPS, FEDEX, ONTRAC, CANADA_POST]; // displayed only when user has no personal 'own' carrier accounts
export const carriersInOrder = [
  ...topCarriers,
  ...carriers
    .filter((carrier) => topCarriers.findIndex((topCarrier) => topCarrier.id === carrier.id) === -1)
    .sort((a, b) => {
      const carrierNameANormalized = a.name.toUpperCase();
      const carrierNameBNormalized = b.name.toUpperCase();

      return carrierNameANormalized < carrierNameBNormalized
        ? -1
        : carrierNameANormalized > carrierNameBNormalized
        ? 1
        : 0;
    }),
  {
    name: 'Other',
  },
];

/**
 * Creates a predicate function to exclude carriers that are deprecated
 * or being rolled out via feature flags.
 * Feature flag decisions are computed once per factory invocation.
 * @returns A predicate function that returns true if the carrier is enabled, false otherwise.
 */
const makeEnabledCarriersPredicate = () => {
  // Compute feature flag decisions once
  const dhlGermanyDeprecated = decideFeatureFlag(FeatureFlags.DHL_GERMANY_SUPPORT_DEPRECATED) ?? {
    enabled: false,
  };

  const amazonShippingAccountConnection = decideFeatureFlag(
    FeatureFlags.AMAZON_SHIPPING_ACCOUNT_CONNECTION,
  ) ?? { enabled: false };

  // Return the predicate function that closes over the computed flag values
  return (c: Carrier) => {
    // Deprecated carriers
    if (defunctCarriers.includes(c)) return false;

    if (dhlGermanyDeprecated.enabled && [DHL_GERMANY, DHL_GERMANY_C2C].includes(c)) return false;

    // Rollout new carriers
    if (!amazonShippingAccountConnection.enabled && AMAZON_SHIPPING === c) return false;

    return true;
  };
};

export const getCarriersInSegments = () => {
  // Create the predicate once per function invocation
  const enabledCarriers = makeEnabledCarriersPredicate();

  // Define segments with their carriers
  const segments = {
    Featured: [FEDEX, UPS, DHL_EXPRESS, AMAZON_SHIPPING],
    'Next-day Delivery': [FEDEX, UPS, DHL_ECOMMERCE, AXLEHIRE, CDL, LSO, GLS_US],
    'Regional Delivery': [
      FEDEX,
      UPS,
      CANADA_POST,
      AUSTRALIA_POST,
      AXLEHIRE,
      AIRTERRA,
      BETTER_TRUCKS,
      CDL,
      DEUTSCHE_POST,
      DHL_GERMANY,
      DHL_ECOMMERCE,
      DPD_UK,
      GLS_US,
      HERMES_UK,
      LASERSHIP,
      LSO,
      NEWGISTICS,
      ONTRAC,
      // PCF,
      RR_DONNELLEY,
      SENDLE,
      SWYFT,
      UDS,
      VEHO,
      X_DELIVERY,
    ],
    'National Delivery': [
      FEDEX,
      UPS,
      CANADA_POST,
      AUSTRALIA_POST,
      AIRTERRA,
      COURIERSPLEASE,
      DEUTSCHE_POST,
      DHL_GERMANY,
      DHL_ECOMMERCE,
      DPD_UK,
      HERMES_UK,
      MONDIALRELAY,
      NEWGISTICS,
      ORANGEDS,
      RR_DONNELLEY,
      SENDLE,
      X_DELIVERY,
    ],
    'International Delivery': [
      FEDEX,
      UPS,
      DHL_EXPRESS,
      CANADA_POST,
      APC_POSTAL,
      ASENDIA_US,
      AUSTRALIA_POST,
      AIRTERRA,
      COURIERSPLEASE,
      DEUTSCHE_POST,
      DHL_GERMANY,
      DHL_ECOMMERCE,
      GLOBEGISTICS,
      HERMES_UK,
      NEWGISTICS,
      ORANGEDS,
      PASSPORT,
      PUROLATOR,
      RR_DONNELLEY,
    ],
  };

  // Apply filtering to all segments automatically
  return Object.entries(segments).reduce(
    (filteredSegments, [segmentName, carriers]) => {
      filteredSegments[segmentName] = carriers.filter(enabledCarriers);
      return filteredSegments;
    },
    {} as Record<string, Carrier[]>,
  );
};

// Carriers where test accounts must be test accounts and not live accounts
export const mustBeActualTestAccounts = ['fedex'];

// Carriers with valid 'Create' forms
// UPS uses carrier_accounts/register/new endpoint for Create calls, all others (i.e. CP) currently use carrier_accounts endpoint (legacy)
export const createFormCarriers = ['ups', 'canada_post'];
export const createEndpointCarriers = ['ups', 'dhl_express', 'amazon_shipping']; // Remove this constant once CP is supported in endpoint carrier_accounts/register/new

export const carriersInOriginCountry = {
  USA: [
    FEDEX,
    UPS,
    DHL_EXPRESS,
    DHL_ECOMMERCE,
    GLS_US,
    LASERSHIP,
    LSO,
    NEWGISTICS,
    ONTRAC,
    // PCF,
    RR_DONNELLEY,
    GLOBEGISTICS,
    ASENDIA_US,
    APC_POSTAL,
    AXLEHIRE,
    PASSPORT,
    X_DELIVERY,
    SWYFT,
    AMAZON_SHIPPING,
  ],
  Canada: [FEDEX, UPS, DHL_EXPRESS, CANADA_POST, PUROLATOR],
  Australia: [FEDEX, UPS, DHL_EXPRESS, AUSTRALIA_POST, COURIERSPLEASE, SENDLE],
  'United Kingdom (UK)': [HERMES_UK, DPD_UK],
  Germany: [FEDEX, UPS, DHL_EXPRESS, DEUTSCHE_POST, DHL_GERMANY],
  France: [MONDIALRELAY],
  Belgium: [MONDIALRELAY],
  'Multiple Countries': [FEDEX, UPS, DHL_EXPRESS, COURIERSPLEASE, MONDIALRELAY, ORANGEDS],
};

export const CARRIERS_WITH_GST = [
  // Goods and Services Tax
  COURIERSPLEASE,
  AUSTRALIA_POST,
  FASTWAY_AUSTRALIA,
  SENDLE,
];

export const CARRIER_MANIFEST_ABOUT_COPY = {
  [USPS.id]: `carrierAboutCopy.${USPS.id}`,
  [AUSTRALIA_POST.id]: `carrierAboutCopy.${AUSTRALIA_POST.id}`,
  [CANADA_POST.id]: `carrierAboutCopy.${CANADA_POST.id}`,
  [DHL_ECOMMERCE.id]: `carrierAboutCopy.${DHL_ECOMMERCE.id}`,
  [NEWGISTICS.id]: `carrierAboutCopy.${NEWGISTICS.id}`,
};

export const LARGE_UPS_GIRTH = 165; // in inches
export const LARGE_UPS_LENGTH = 108; // in inches
export const LARGE_UPS_WEIGHT = 150; // in lb

export const LARGE_UPS_THRESHOLD = 0.95;
export const LARGE_UPS_SURCHARGE_USD = 1875;

export default carriers;
